/**
 * Bulk actions — act on a selection of items as a group.
 *
 * Every dialog here takes the selected ids, shows what is about to happen in
 * one sentence, applies the change one item at a time through the store's
 * reporting write path, and hands back a BulkActionResult that says what
 * actually saved. The list keeps the failed items selected so they can be
 * tried again or opened.
 */

export interface BulkActionFailure {
  itemId: string;
  itemTitle: string;
  reason: string;
}

export interface BulkActionResult {
  /** The verb, as a short past-tense label: "Deferred", "Tagged", "Moved to Queue". */
  action: string;
  total: number;
  succeeded: number;
  succeededIds: string[];
  failed: BulkActionFailure[];
}

/** "14 items" / "1 item". */
export function itemsWord(n: number): string {
  return `${n} item${n === 1 ? '' : 's'}`;
}

export { runBulk } from './runBulk';
export { BulkAssignOwnerModal } from './BulkAssignOwnerModal';
export { BulkTagsModal } from './BulkTagsModal';
export { BulkChangeQueueModal } from './BulkChangeQueueModal';
export { BulkChangeStateModal } from './BulkChangeStateModal';
export { BulkAddToSessionModal } from './BulkAddToSessionModal';
export { BulkSetFieldModal } from './BulkSetFieldModal';
export { BulkResultsDialog } from './BulkResultsDialog';
